<template>
    <div class="table-loading">
        <FontAwesomeIcon
            icon="spinner"
            size="3x"
            pulse
            class="mb-2"
        />

        <h2 class="table-loading-title">
            <!-- Text to show when loading/busy -->
            <slot>
                <!-- `Loading...` -->
                Loading...
            </slot>
        </h2>
    </div>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core';
    import {faSpinner} from '@fortawesome/pro-solid-svg-icons';
    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

    library.add(faSpinner);

    /**
     * @group Tables
     * A component to display a custom loading/busy state on a `b-table`.
     */
    export default {
        name: 'TableLoading',
        components: {FontAwesomeIcon},
    };
</script>
